import activitylogApi from 'api/activitylog';
import { call, put, takeLatest } from 'redux-saga/effects';
import { activitylogAction, GetLogsPayload } from './activitylogSlice';
import { PayloadAction } from '@reduxjs/toolkit';

// ── Fetch Modules ─────────────────────────────────────────────────────────────
function* fetchModules(): Generator<any, void, any> {
  try {
    const response: any = yield call(activitylogApi.getModules);
    const data = response.data;
    if (data.success) {
      yield put(activitylogAction.getModulesSuccess(data));
    } else {
      yield put(activitylogAction.getModulesFailed({ message: data.message }));
    }
  } catch (error: any) {
    yield put(
      activitylogAction.getModulesFailed({
        message: error?.response?.data?.message || 'Failed to fetch modules',
      })
    );
  }
}

// ── Fetch Logs ────────────────────────────────────────────────────────────────
function* fetchActivityLogs(action: PayloadAction<GetLogsPayload>): Generator<any, void, any> {
  const isAppend = Boolean(
    action.payload?.nextCursor ||
    (action.payload?.page && action.payload.page > 1)
  );
  const targetTab =
    action.payload?.tab ||
    (action.payload?.module === 'apiRequests' ? 'admin' : 'backend');

  try {
    const response: any = yield call(activitylogApi.getLogs, action.payload);
    const data = response.data;
    if (data?.success !== false) {
      yield put(
        activitylogAction.getActivityLogsSuccess({
          res: data,
          tab: targetTab,
          isAppend,
          requestedLimit: action.payload?.limit || 20,
        })
      );
    } else {
      yield put(
        activitylogAction.getActivityLogsFailed({
          message: data?.message || 'Failed to fetch logs',
          tab: targetTab,
          isAppend,
        })
      );
    }
  } catch (error: any) {
    yield put(
      activitylogAction.getActivityLogsFailed({
        message: error?.response?.data?.message || error?.message || 'Failed to fetch logs',
        tab: targetTab,
        isAppend,
      })
    );
  }
}

export default function* activitylogSaga() {
  yield takeLatest(activitylogAction.getModules.type, fetchModules);
  yield takeLatest(activitylogAction.getActivityLogs.type, fetchActivityLogs);
}

